import React, { ReactElement } from "react";
import { Swiper, SwiperSlide, useSwiper } from "swiper/react";
import { Star01, ArrowLeft, ArrowRight } from "@untitled-ui/icons-react";
import styles from "./testimonials.module.scss";

export const Testimonials = (props: Props): ReactElement => {
  return (
    <section className={styles.section}>
      <div className={styles.wrapper}>
        <Swiper slidesPerView={1} loop={props.items && props.items.length > 1}>
          {props.items?.map((item, slideIndex) => (
            <SwiperSlide key={`slide_${slideIndex}`}>
              <div className={styles.sliderContainer}>
                <img
                  src={item.image}
                  alt={item.text}
                  loading="lazy"
                  className={styles.image}
                />
                <div className={styles.quote}>
                  <div className={styles.starWrapper}>
                    {Array.from(Array(item.rating || 0)).map((s, t) => (
                      <Star01
                        key={`star_${t}`}
                        color="#FEC84B"
                        viewBox="0 0 24 24"
                      />
                    ))}
                  </div>
                  <p className={styles.text}>{item.text}</p>
                  <div className={styles.userMetaWrapper}>
                    {item.usericon && (
                      <img src={item.usericon} alt={item.text} loading="lazy" />
                    )}
                    <div className={styles.textWrapper}>
                      <p className={styles.username}>{item.username}</p>
                      <p className={styles.userlabel}>{item.userlabel}</p>
                    </div>
                    {props.items?.length > 1 && (
                      <div className={styles.prevNextWrapper}>
                        <PrevButton />
                        <NextButton />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

const PrevButton = () => {
  const swiper = useSwiper();

  return (
    <button
      className={styles.prevNextButton}
      onClick={() => swiper.slidePrev()}
    >
      <ArrowLeft />
    </button>
  );
};

const NextButton = () => {
  const swiper = useSwiper();

  return (
    <button
      className={styles.prevNextButton}
      onClick={() => swiper.slideNext()}
    >
      <ArrowRight />
    </button>
  );
};

interface Props {
  items: {
    image: string;
    rating: number;
    text: string;
    username: string;
    userlabel: string;
    usericon: string;
  }[];
}
